/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EnterpriseDashboardComponent } from './enterprise-dashboard.component';

const appRoutes: Routes = [{ path: '', component: EnterpriseDashboardComponent }];

@NgModule({
	imports: [RouterModule.forChild(appRoutes)],
	exports: [RouterModule],
})
export class EnterpriseDashboardRoutingModule {}
